<template>
  <b-badge :variant="dataStatus[status].variantColor">
    {{ dataStatus[status].label }}
  </b-badge>
</template>
<script>
export default {
  props: {
    status: { type: String, default: '' },
  },
  data() {
    return {
      dataStatus: [
        {},
        { label: 'Belum Input Keberadaan', variantColor: 'light-secondary' },
        { label: 'Belum Validasi Keberadaan', variantColor: 'light-info' },
        { label: 'Dikembalikan Keberadaan', variantColor: 'light-danger' },
        { label: 'Melakukan Input Pada Web', variantColor: 'light-success' },
        {
          label: 'Menunggu Validasi Data Informasi',
          variantColor: 'light-info',
        },
        {
          label: 'Dikembalikan Validasi Data Informasi',
          variantColor: 'light-danger',
        },
        { label: 'Belum Cetak QR', variantColor: 'light-secondary' },
        { label: 'Belum Scan QR dan Foto', variantColor: 'light-primary' },
        { label: 'Selesai Inventarisasi', variantColor: 'light-success' },
      ],
    }
  },
}
</script>
